import * as React from 'react';
import Container from "@mui/material/Container";

const FullWidthContainer = (props) => <Container {...props} disableGutters={true} maxWidth="false"/>

export default FullWidthContainer;